import * as t from 'io-ts';
import { ConfigLayer, mergeConfig } from 'utils/config';
import { defineModels, ModelType } from 'utils/types/models';

// Define a category of Models for storing configuration
const ConfigModel = defineModels({
  FrontendConfig: {
    ENV: t.string,
    API_KEY: t.string,
    API_BASE_URL: t.string,
    API_ENDPOINT_HTAAPI: t.string,
    CHAT_QUEUE_ID: t.number,
    // Feature flags: these (and only these!) values can be changed during runtime via the query string.
    // The distinction is made by the config key name: keys that match /^FEATURE_/ are allowed, others not.
    FEATURE_LOGGING: t.boolean,
  },
});

// Export the compile-time types with a separate name, so both them and the run-time types can be imported at the same time, where needed
export type ConfigModelType = ModelType<typeof ConfigModel>;

// If no config overrides are used, this config will be used
const defaultConfig: Readonly<ConfigModelType> = {
  FrontendConfig: {
    ENV: '',
    API_KEY: '',
    API_BASE_URL: 'API_URL_NOT_SET',
    API_ENDPOINT_HTAAPI: 'API_URL_NOT_SET',
    CHAT_QUEUE_ID: 0, // TODO This might be better as undefined
    FEATURE_LOGGING: false,
  },
};

// Convenience function for using mergeConfig() to produce a FrontendConfig, as that's what it's almost always used for
export function mergeFrontendConfig(...layers: ConfigLayer[]): ConfigModelType['FrontendConfig'] {
  return mergeConfig(ConfigModel.FrontendConfig as any, defaultConfig.FrontendConfig, layers);
}
